
import React, { Component } from "react";
import { connect } from "react-redux";
class NotFound extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}


render()
    {	
	 
		return (
            <div className="bg wrapper sitemain">
            <div className="gradient">

                <div className="container">
                    <img src="../../assets/images/error/404.png" className="img-fluid mb-4 w-50" alt=""/> 
                    <h2 className="mb-0 mt-4 text-primary">Oops! This Page is Not Found.</h2>
                    <h5 className="mt-4 text-primary">The requested page dose not exist.</h5>
                    <a className="btn  mt-4 bg-white text-primary bold d-inline-flex align-items-center" href="/">Back to Home</a>
                </div>
            </div>
        </div>
                
   
		);
	}
}

function mapStateToProps(state) {

}

export default connect(mapStateToProps)(NotFound);





